import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import NewReleasesIcon from '@mui/icons-material/NewReleases'
import {
  Collapse,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import { permissionValidation } from '@novafuturltd/shared'
import { useRouter } from 'next/router'
import React, { FC, useState } from 'react'
import { useIntl } from 'react-intl'
// @todo external
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useStyles } from '../../../../containers/Sidebar/Sidebar.styles'
// @todo external
import { MenuFeatures } from './check-release'

interface Props {
  permissions: string[]
  openDrawer: boolean
  hoverDrawer: boolean
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
  toggleOpen: (open: boolean) => void
}

const HrBotBoSubMenu: FC<Props> = ({
  permissions,
  openDrawer,
  hoverDrawer,
  toggleDrawerOnMobile,
  toggleOpen,
}) => {
  const intl = useIntl()
  const classes = useStyles({ openDrawer, hoverDrawer })
  const { pathname } = useRouter()
  const [open, setOpen] = useState(pathname.includes('check-release/'))
  const handleClick = () => {
    setOpen(!open)
  }

  return permissionValidation(
    permissions,
    'release_orchestrator.check_release',
  ) ? (
    <MenuList aria-labelledby="nested-list-subheader" className={classes.root}>
      <MenuItem
        key="release-check"
        data-test="release-check_sidebar_submenu"
        onClick={handleClick}
        className={classes.menuItem}
        selected={
          !openDrawer && !hoverDrawer && pathname.includes('check-release/')
        }
      >
        <ListItemIcon data-test="release-check_sidemenu_icon">
          <NewReleasesIcon
            style={{ fill: '#F59C0D', width: '24px', height: '24px' }}
          />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({ id: 'release-check.sidebar' })}
          hidden={!openDrawer && !hoverDrawer}
        />
        {open ? (
          <ExpandLess
            onClick={() => toggleOpen(true)}
            className={classes.expandIcon}
          />
        ) : (
          <ExpandMore
            onClick={() => toggleOpen(true)}
            className={classes.expandIcon}
          />
        )}
      </MenuItem>
      <Collapse in={open} timeout="auto" hidden={!openDrawer && !hoverDrawer}>
        <MenuList disablePadding={true}>
          {permissionValidation(
            permissions,
            'release_orchestrator.check_release.list',
          ) && (
            <MenuFeatures
              pathname={pathname}
              nested={
                openDrawer || hoverDrawer
                  ? classes.nested
                  : classes.nestedClosed
              }
              toggleDrawerOnMobile={toggleDrawerOnMobile}
            />
          )}
        </MenuList>
      </Collapse>
    </MenuList>
  ) : null
}

export default HrBotBoSubMenu
